module.exports = require("@glimmer/component");